module.exports = __webpack_public_path__ + "img/miyazaki.a9f2b96f.jpg";